import type { FC } from 'react';
import FormPageLayout from '../components/FormPageLayout';
import { useEffect } from 'react';

const GenerateApiKeyPage: FC = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://formaloo.net/istatic/js/main.js';
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);
  return (
    <FormPageLayout>
      <div
        id="formz-wrapper"
        data-formz-slug="XPgJTtp3"
        data-formz-type="simple"
      />
    </FormPageLayout>
  );
};

export default GenerateApiKeyPage;
